import React, { useCallback, useEffect, useState } from "react";
import Layout from "../../common/Layout";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect from "react-select";
import { GetDataWithToken, PostDataWithToken } from "../../constants/ApiHelper";
import { FaPlus } from "react-icons/fa";
import _ from "lodash";
import { toast } from "react-toastify";
import { dispatchMmvData } from "../../store/actions/userActions";
import ReactPaginate from "react-paginate";
import { ImTab } from "react-icons/im";

const AddRto = () => {
    const dispatch = useDispatch();

    const mmvData = useSelector((state) => state?.root?.mmvData);

    const [loading, setLoading] = useState(false);
    const [addNewRto, setAddNewRto] = useState(false)
    const [partnerRtoData, setPartnerRtoData] = useState([])

    const [stateData, setStateData] = useState([]);
    const [cityData, setCityData] = useState([]);
    const [rtoData, setRtoData] = useState([]);

    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedRto, setSelectedRto] = useState(null);

    const [stateId, setStateId] = useState("");
    const [cityId, setCityId] = useState("");

    const [stateModal, setStateModal] = useState(false);
    const [cityModal, setCityModal] = useState(false);
    const [rtoModal, setRtoModal] = useState(false);

    const [addState, setAddState] = useState("");
    const [addCity, setAddCity] = useState("");
    const [addRtoCode, setAddRtoCode] = useState("");
    const [addRtoName, setAddRtoName] = useState("");
    const [variantIdInput, setVariantIdInput] = useState('')

    const [pageCount, setPageCount] = useState()
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [itemOffset, setItemOffset] = useState(0)
    const handlePageClick = e => {
        const newOffset = e.selected * itemsPerPage
        setItemOffset(newOffset)
    }

    const endOffset = itemOffset + itemsPerPage

    const [showSidebar, setShowSidebar] = useState(false);


    const [formData, setFormData] = useState({
        registered_state_name: "",
        registered_city_name: "",
        RTO_Code: "",
        rto_name: "",
    });


    // ===========================
    // Get States
    // ===========================
    const getStateData = async () => {
        try {
            setLoading(true);

            const res = await PostDataWithToken("/state/getStates", {
                status: "1",
                stateId: "",
            });

            if (res?.status) {
                const arr =
                    res?.data?.map((item) => ({
                        label: item.state,
                        value: item.stateId,
                    })) || [];

                setStateData(arr);
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to load states");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getStateData();
    }, []);

    // ===========================
    // Get Cities
    // ===========================
    const getCityData = async (selectedStateId) => {
        try {
            setLoading(true);

            setCityData([]);
            setRtoData([]);
            setSelectedCity(null);
            setSelectedRto(null);

            const res = await PostDataWithToken("/cities/getCities", {
                status: 1,
                stateId: String(selectedStateId),
                cityId: "",
            });

            const arr =
                res?.data?.map((item) => ({
                    label: item.city,
                    value: item.cityId,
                })) || [];

            setCityData(arr);
        } catch (error) {
            console.error(error);
            toast.error("Failed to load cities");
        } finally {
            setLoading(false);
        }
    };

    // ===========================
    // Get RTO
    // ===========================
    const getRtoData = async (selectedCityId) => {
        try {
            setLoading(true);

            const res = await PostDataWithToken("/rto/getRtoCode", {
                stateId,
                cityId: selectedCityId,
            });

            if (res?.status) {
                const arr =
                    res?.data?.map((item) => ({
                        label: item.RTO_Code,
                        value: item.RTO_Code,
                    })) || [];

                setRtoData(arr);
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to load RTO");
        } finally {
            setLoading(false);
        }
    };

    // ===========================
    // Select Handlers
    // ===========================
    const handleSelectState = (option) => {
        setSelectedState(option);
        setStateId(option.value);

        // dispatch(dispatchMmvData("stateId", option.value));
        // dispatch(dispatchMmvData("state", option.label));

        getCityData(option.value);
    };

    const handleSelectCity = (option) => {
        setSelectedCity(option);
        setCityId(option.value);

        // dispatch(dispatchMmvData("cityId", option.value));
        // dispatch(dispatchMmvData("city", option.label));

        getRtoData(option.value);
    };

    const handleSelectRto = (option) => {
        setSelectedRto(option);

        // dispatch(dispatchMmvData("rtoCode", option.value));
    };

    // ===========================
    // Debounce
    // ===========================
    const handleChangeMake = useCallback(
        _.debounce((value) => {
            console.log(value);
        }, 500),
        []
    );

    // ===========================
    // Inputs
    // ===========================
    const handleAddState = (e) => {
        setAddState(e.target.value);
        handleChangeMake(e.target.value);
    };

    const handleAddCity = (e) => {
        setAddCity(e.target.value);
        handleChangeMake(e.target.value);
    };

    const handleAddRto = (e) => {
        setAddRtoCode(e.target.value);
        handleChangeMake(e.target.value);
    };

    const handleAddRtoName = (e) => {
        setAddRtoName(e.target.value);
    };

    // ===========================
    // Submit
    // ===========================
    const handleAddMmv = async () => {
        try {
            setLoading(true);

            const payload = {
                vehicleType: mmvData?.vehicleType || "",

                registered_state_name: addState || selectedState?.label || "",
                stateId: stateId || "",

                registered_city_name: addCity || selectedCity?.label || "",
                cityId: cityId || "",

                RTO_Code: addRtoCode || selectedRto?.value || "",
                rto_name: addRtoName || "",
            };

            console.log("Payload", payload);

            const response = await PostDataWithToken(
                "/rto/addRtoMaster",
                payload
            );

            if (
                response?.status === "success" ||
                response?.status === true
            ) {
                toast.success(response.message);
            } else {
                toast.error(
                    response?.message
                );
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to add MMV");
        } finally {
            setLoading(false);
        }
    };

    const currentItems =
        partnerRtoData && partnerRtoData.slice(itemOffset, endOffset)

    const getPartnerRto = (val1, val2, val3, val4) => {
        setLoading(true)
        let partnerObj = {
            stateId: val1 === mmvData?.makeId ? mmvData?.makeId : val1,
            vehicleType: '',
            insurerId: '',
            rtoFullName: "",
            cityId: val2 === mmvData?.cityId ? mmvData?.cityId : val2,
            RTO_Code: val3 !== '' ? val3 : val3,
             search: variantIdInput,
            action: val4 !== '' ? val4 : ''
        }

        PostDataWithToken('/rto/getRtoData', partnerObj).then(
            res => {
                setPartnerRtoData(res?.data)
                setPageCount(Math.ceil(res?.data.length / itemsPerPage))
                setLoading(false)
            }
        )
        // setModel(true)
    }
    useEffect(() => {
        if (mmvData?.apiUrl) {
            getPartnerRto();

        }
    }, [mmvData?.apiUrl]);
    const handleChangeItemPerPage = e => {
        setItemsPerPage(e)
    }
    const handleEditClick = (item) => {
     
        setSelectedRto(item);

        setFormData({
            registered_state_name: item?.registered_state_name || "",
            registered_city_name: item?.registered_city_name || "",
            RTO_Code: item?.RTO_Code || "",
            rto_name: item?.rto_name || "",
        });

        setShowSidebar(true);
    };
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

const handleUpdateRto = async () => {
    try {
        const response = await PostDataWithToken(
            `/rto/updateRtoMaster/${selectedRto?.id}`,
            formData,
            ""
        );

        console.log("response", response);

        if (response?.status === true) {
            setShowSidebar(false);

            toast.success(
                response?.message || "RTO updated successfully"
            );

            // Refresh Table Data
            getPartnerRto();
        } else {
            toast.error(
                response?.message || "Failed to update RTO"
            );
        }
    } catch (error) {
        console.error("Update RTO Error:", error);

        toast.error(
            error?.response?.data?.message ||
            "Failed to update RTO"
        );
    }
};
    const handleVariantIdChange = e => {
        setVariantIdInput(e.target.value)
    }
    const [searchType, setSearchType] = useState('search')
    const handleSearch = () => {
        if (searchType === 'search') {
            getPartnerRto('', '','', variantIdInput)
            setSelectedState(null)
            setSelectedCity(null)
            setSelectedRto(null)
        } 
    }
    const handleStatusToggle = async (item) => {
        try {
            setLoading(true);

            const newStatus = !item.status;

            const response = await GetDataWithToken(
                `rto/updateRtoStatus/${item.id}/status=${newStatus}`
            );

            console.log("Status Updated:", response);
toast.success(response.message);
            // Refresh Data
            getPartnerRto();

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout>
            <div className="container-fluid py-4 dash_main">
                <div className="card">
                    <div className="card-body pt-0 pb-2 d-dlex align-itme-center d-flex justify-content-between">
                        <div className='col-xl-3 col-lg-3 col-md-6 col-12 d-flex align-items-center gao-1'>
                            <div>
                                <label>RTO Code</label>
                                <div className='mb-3'>
                                    <input
                                        type='search'
                                        placeholder='RTO CODE'
                                        className='form-control'
                                        value={variantIdInput}
                                        onChange={handleVariantIdChange}
                                    />
                                </div>
                            </div>
                            <div
                                className='mt-3 secrch-btn'
                                onClick={() => handleSearch()}
                            >
                                <button>search</button>
                            </div>
                        </div>

                        <div>
                            <button className="btn btn-sec" onClick={() => setAddNewRto(!addNewRto)}>Add Rto</button>
                        </div>

                    </div>

                </div>
                <div className="card">
                    {addNewRto && (
                        <div className="card-body">

                            <div className="row">

                                {/* STATE */}
                                <div className="col-md-4">

                                    <div className="d-flex ">
                                        <div className="col-10">
                                            <label>State</label>
                                            <div className="w-100">
                                                <ReactSelect
                                                    options={stateData}
                                                    value={selectedState}
                                                    placeholder="Select State"
                                                    onChange={handleSelectState}
                                                />
                                            </div>
                                        </div>

                                        <div
                                            className="add-sec"
                                            onClick={() => setStateModal(!stateModal)}
                                        >
                                            <FaPlus />
                                        </div>
                                    </div>

                                    {stateModal && (
                                        <input
                                            type="text"
                                            className="form-control mt-2"
                                            placeholder="Enter State"
                                            value={addState}
                                            onChange={handleAddState}
                                        />
                                    )}
                                </div>

                                {/* CITY */}
                                <div className="col-md-4">


                                    <div className="d-flex ">
                                        <div className="col-10">
                                            <label>City</label>
                                            <div className="w-100">
                                                <ReactSelect
                                                    options={cityData}
                                                    value={selectedCity}
                                                    placeholder="Select City"
                                                    onChange={handleSelectCity}
                                                />
                                            </div>
                                        </div>

                                        <div
                                            className="add-sec"
                                            onClick={() => setCityModal(!cityModal)}
                                        >
                                            <FaPlus />
                                        </div>
                                    </div>

                                    {cityModal && (
                                        <input
                                            type="text"
                                            className="form-control mt-2"
                                            placeholder="Enter City"
                                            value={addCity}
                                            onChange={handleAddCity}
                                        />
                                    )}
                                </div>

                                {/* RTO */}

                                <div className='col-xl-4 col-lg-4 col-md-6 col-12'>
                                    <div className='d-flex'>
                                        <div className='col-10'>
                                            <label>RTO Code</label>
                                            <ReactSelect
                                                options={rtoData}
                                                value={selectedRto}
                                                placeholder="Select RTO"
                                                onChange={handleSelectRto}
                                            />

                                        </div>

                                        <div>
                                            <div
                                                className="add-sec"
                                                onClick={() => setRtoModal(!rtoModal)}
                                            >
                                                <FaPlus />
                                            </div>
                                        </div>

                                    </div>

                                    <div className='mt-2'>
                                        {rtoModal && (
                                            <input
                                                type="text"
                                                className="form-control mt-2"
                                                placeholder="Enter RTO Code"
                                                value={addRtoCode}
                                                onChange={handleAddRto}
                                            />
                                        )}
                                        <div>
                                        </div>
                                    </div>

                                </div>

                                {/* RTO NAME */}
                                <div className="col-md-4 mt-3">

                                    <label>RTO Name</label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter RTO Name"
                                        value={addRtoName}
                                        onChange={handleAddRtoName}
                                    />
                                </div>
                            </div>

                            <div className="d-flex justify-content-end mt-4">
                                <button
                                    className="btn btn-sec"
                                    onClick={handleAddMmv}
                                    disabled={loading}
                                >
                                    {loading ? "Loading..." : "Submit"}
                                </button>
                            </div>

                        </div>
                    )}

                </div>
                <div className='card-body pt-0 pb-2'>
                    <div className='table-responsive p-0'>
                        <table className="table align-items-center mb-0">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>State</th>
                                    <th>City</th>
                                    <th>RTO Code</th>
                                    <th>RTO Name</th>
                                    <th>Full Name</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {currentItems?.length > 0 ? (
                                    currentItems.map((item) => (
                                        <tr key={item.id}>
                                            <td>{item?.id}</td>
                                            <td>{item?.registered_state_name}</td>
                                            <td>{item?.registered_city_name}</td>
                                            <td>{item?.RTO_Code}</td>
                                            <td>{item?.rto_name}</td>

                                            <td>{item?.rtoFullName}</td>
                                            <td>
                                                <td>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <div
                                                            className={`custom-switch ${item?.status ? "active" : ""}`}
                                                            onClick={() => handleStatusToggle(item)}
                                                        >
                                                            <div className="switch-circle"></div>
                                                        </div>

                                                        <span
                                                            className={`fw-semibold ${item?.status ? "text-success" : "text-danger"
                                                                }`}
                                                        >

                                                        </span>
                                                    </div>
                                                </td>
                                            </td>

                                            <td>
                                                <button
                                                    type="button"
                                                    className="btn btn-success btn-sm"
                                                    onClick={() => handleEditClick(item)}
                                                >
                                                    Update
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center">
                                            No Data Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='card mb-4 p-3'>
                    <div className='d-flex align-items-center justify-content-between flex-wrap'>
                        <div>
                            <p>
                                Showing 1 - {itemsPerPage} items of{' '}
                                {partnerRtoData?.length}
                            </p>
                        </div>
                        <div className='main-page-item'>
                            <div className='show-page'>
                                <select
                                    className='form-control'
                                    onClick={e =>
                                        handleChangeItemPerPage(e?.target?.value)
                                    }
                                >
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={30}>30</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>
                            <div>
                                <ReactPaginate
                                    breakLabel='...'
                                    nextLabel='>'
                                    onPageChange={handlePageClick}
                                    pageRangeDisplayed={5}
                                    pageCount={pageCount}
                                    previousLabel='<'
                                    renderOnZeroPageCount={null}
                                    pageClassName='page-item'
                                    pageLinkClassName='page-link'
                                    previousClassName='page-item'
                                    previousLinkClassName='page-link'
                                    nextClassName='page-item'
                                    nextLinkClassName='page-link'
                                    breakClassName='page-item'
                                    breakLinkClassName='page-link'
                                    containerClassName='pagination'
                                    activeClassName='active'
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {showSidebar && (
                <>
                    <div
                        className="position-fixed top-0 start-0 w-100 h-100"
                        style={{
                            background: "rgba(0,0,0,0.4)",
                            zIndex: 1040,
                        }}
                        onClick={() => setShowSidebar(false)}
                    />

                    <div
                        className="position-fixed top-0 end-0 bg-white shadow"
                        style={{
                            width: "450px",
                            height: "100vh",
                            zIndex: 1050,
                            overflowY: "auto",
                            padding: "20px",
                        }}
                    >
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h4>Edit RTO</h4>

                            <button
                                className="btn-close"
                                onClick={() => setShowSidebar(false)}
                            />
                        </div>

                        <div className="mb-3">
                            <label>State Name</label>
                            <input
                                type="text"
                                className="form-control"
                                name="registered_state_name"
                                value={formData.registered_state_name}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="mb-3">
                            <label>City Name</label>
                            <input
                                type="text"
                                className="form-control"
                                name="registered_city_name"
                                value={formData.registered_city_name}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="mb-3">
                            <label>RTO Code</label>
                            <input
                                type="text"
                                className="form-control"
                                name="RTO_Code"
                                value={formData.RTO_Code}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="mb-3">
                            <label>RTO Name</label>
                            <input
                                type="text"
                                className="form-control"
                                name="rto_name"
                                value={formData.rto_name}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="d-flex gap-2">
                            <button
                                className="btn suc-btn"
                                onClick={handleUpdateRto}
                            >
                                Update
                            </button>

                            <button
                                className="btn btn-secondary"
                                onClick={() => setShowSidebar(false)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </>
            )}
            {loading && (
                <div className="loader-overlay">
                    <div className="text-center">
                        <div
                            className="spinner-border text-primary"
                            role="status"
                        />
                        <h5 className="mt-3">
                            Updating Status...
                        </h5>
                    </div>
                </div>
            )}
        </Layout>
    );
};

export default AddRto;